import React, { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import { ChevronLeft, ChevronRight } from "react-feather";
import Select from "react-select";
import ReactTooltip from "react-tooltip";
import { requestObjectTypeDictionary, tabHeadingDictionary as tabKeywords, redirectionCompanyTypeDictionary as redirectionCompanyTypeEnum, timeFrameOptions } from "@core/global/global-country-dictionary";
import ImporterExporterGraph from "@shared/country-components/importer-exporter-graph";
import TabHeader from "@shared/country-components/tabHeader";
import ReactTableTrademo from "@shared/trademo-datatable/react-table-trademo";
import { TrendsData } from "@shared/unique-importer-exporter-trends";
import { searchTypeCustomStyles } from "@utils/utils";
import Filters from "../components/InternalFilter/filter";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import ImportExportImg from "@assets/images/uniqueexporters&importers.svg";
import UpgradeIcon from "@assets/images/Solid_Status_Lightning-alt.svg";
import { secondLevelRowsDropdown } from "@utils/enum";
import DataTable from "react-data-table-component";
import AscSortIcon from "@assets/images/AscSortIcon";
import DescSortIcon from "@assets/images/DescSortIcon";
import DemoTouchPoint from "@routes/intel/onboarding-screens/onboarding/VideoOpenerStrip";
import DynamicDropdown from "@components/base/DynamicDropDown/DynamicDropDown";
import { Tooltip as ReactTooltip5 } from "react-tooltip5";

const Exporter = (props) => {
  useEffect(() => {
    let val = document.querySelectorAll(".lvl-two-table-container-left .rdt_Pagination select option");
    if (!!val && !!val.length) {
      val[0].textContent = 5;
      val[1].textContent = 10;
      val[2].textContent = 20;
    }
    let range = document.querySelectorAll(".lvl-two-table-container-left .rdt_Pagination span");
    if (!!range && !!range.length) {
      let toPage = (props.defaultPage * props.exporterPerPage) / props.secondLevelRowDropdownValue.value - 1;
      let fromPage = toPage - props.exporterPerPage / props.secondLevelRowDropdownValue.value + 1;
      range[1].textContent = props.totalUniqueExporter >= 5 ? `${fromPage + 1} - ${toPage + 1 > props.totalUniqueExporter ? props.totalUniqueExporter : toPage + 1} of ${props.totalUniqueExporter}` : `${fromPage + 1} - ${props.totalUniqueExporter} of ${props.totalUniqueExporter}`;
    }
    let prevPage = document.querySelectorAll(".lvl-two-table-container-left .rdt_Pagination #pagination-previous-page");
    if (!!prevPage && !!prevPage.length && props.defaultPage > 1) {
      prevPage[0].removeAttribute("disabled");
    }
    let totalPages = Math.floor(props.totalUniqueExporter / (props.exporterPerPage / props.secondLevelRowDropdownValue.value)) + 1;
    let nextPage = document.getElementById("pagination-next-page");

    if (nextPage) {
      if (props.defaultPage >= totalPages) {
        nextPage.setAttribute("disabled", true);
        nextPage.style.opacity = "0.4";
        nextPage.style.cursor = "not-allowed";
      } else {
        nextPage.removeAttribute("disabled");
      }
    }
  });

  const customStyles = {
    rows: {
      style: {
        minHeight: "62px",
        maxHeight: "fit-content !important",
        zIndex: 0,
        "&:nth-child(n+0)": {
          borderBottom: "none !important",
        },
      },
    },
    headCells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
        borderRight: "1px solid #eaecf0",
        "&:nth-child(1)": {
          backgroundColor: "white",
          position: "sticky",
          zIndex: 2,
          left: 0,
          minWidth: "285px",
        },
        "&:nth-child(2)": {
          backgroundColor: "white",
          position: "sticky",
          zIndex: 2,
          left: "285px",
        },
        "&:nth-child(n+2)": {
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
          backgroundColor: "white",
          minWidth: "160px !important",
        },
      },
    },
    cells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
        borderRight: "1px solid #eaecf0",
        "&:nth-child(1)": {
          borderBottom: "1px solid #eaecf0",
          backgroundColor: "white",
          position: "sticky",
          zIndex: 2,
          left: 0,
          minWidth: "285px",
        },
        "&:nth-child(2)": {
          borderBottom: "1px solid #eaecf0",
          backgroundColor: "white",
          position: "sticky",
          zIndex: 2,
          left: "285px",
        },
        "&:nth-child(n+2)": {
          display: "flex",
          borderBottom: "1px solid #eaecf0",
          backgroundColor: "white",
          justifyContent: "start",
          alignItems: "center",
          minWidth: "160px !important",
        },
      },
    },
  };

  const [activeDropdown, setActiveDropdown] = useState(null);
  const toggle = (name) => setActiveDropdown(activeDropdown === name ? null : name);
  const close = () => setActiveDropdown(null);
  const fromDate = new Date(props.existingSearchReqObj.fromDate);
  const toDate = new Date(props.existingSearchReqObj.toDate);
  const diffInMs = toDate - fromDate;
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
  const isWithinOneYear = diffInDays <= 730;

  return (
    <div>
      <div className={props.currentTab === tabKeywords.exporters ? "tab-pane fade show active" : "tab-pane fade"} id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
        <div className="trademo-table-container">
          {!!props.currentUserPlan && props.currentUserPlan !== "" && !!props.currentPlanAccess && props.currentPlanAccess.consignee_shipper === false ? (
            <Card className="upgrade-card">
              <Card.Body>
                <div className="container">
                  <div className="row">
                    <div className="col-auto">
                      <div>
                        <img src={UpgradeIcon} alt="..." className="img-fluid" />
                      </div>
                    </div>
                    <div className="col">
                      <p>This feature enables you to view list of unique shipper across the searched shipments with standardised names and after exclusion of logisitic companies</p>
                      <p>Upgrade to higher Pro or Advanced plan to use this feature</p>
                      <div className="d-block my-3">
                        <button type="button" className="btn btn-success tw-bg-secondary-green" onClick={(e) => props.upgradeNow(e)}>
                          Upgrade
                        </button>
                      </div>
                      <div className="d-block">
                        <img src={ImportExportImg} alt="..." className="img-fluid" />
                      </div>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          ) : (
            <div className="tw-flex tw-flex-col">
              <div className="tw-flex tw-flex-col tw-gap-4 tw-py-4">
                <div className="tw-flex tw-w-full tw-justify-start tw-h-9">
                  {!!props.showUiTrends && props.showUiTrends === true ? (
                    <div className="col-md-4 d-flex tw-px-0">
                      <div className="tw-flex tw-border tw-border-gray-200 tw-rounded-lg">
                        <span className={`cursor-pointer tw-text-sm tw-text-gray-900 tw-font-medium tw-py-2 tw-px-4  ${props.exporterTrendsTab === false && props.isExporterTableVisible === true ? "tw-bg-gray-200 tw-font-semibold tw-rounded-l" : "non-selected"}`} onClick={() => props.setExporterTrendsToggle(false)}>
                          Rank
                        </span>
                        {props.isRedirect === true && props.redirectingCompanyType === redirectionCompanyTypeEnum.importer.value && props.defaultData.isImpExpGraph ? (
                          <span className={`cursor-pointer tw-text-sm tw-text-gray-900 tw-font-medium tw-py-2 tw-px-4 ${props.isExporterTableVisible === false && props.exporterTrendsTab === false ? "tw-bg-gray-200 tw-font-semibold" : "non-selected"}`} onClick={() => props.setExporterTableToggle(false)}>
                            Network
                          </span>
                        ) : (
                          ""
                        )}
                        <span className={`cursor-pointer tw-text-sm tw-text-gray-900 tw-font-medium tw-py-2 tw-px-4 ${props.exporterTrendsTab === true ? "tw-bg-gray-200 tw-font-semibold tw-rounded-r" : "non-selected"}`} onClick={() => props.setExporterTrendsToggle(true)}>
                          Trends
                        </span>
                      </div>
                      {props.isExporterTableVisible !== false && props.exporterTrendsTab ? (
                        <div className="sort-dropdown d-flex ml-2 modifying-styling">
                          <div className="custom-dropdown d-flex justify-content-center align-items-center">
                            <Select
                              isSearchable={false}
                              options={timeFrameOptions}
                              defaultValue={props.currentExporterFrame}
                              styles={searchTypeCustomStyles}
                              onChange={(e) => {
                                if (e && e.value && e.value === "year") {
                                  props.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabTrendsYoY);
                                } else if (e && e.value && e.value === "month") {
                                  props.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabTrendsMoM);
                                } else if (e && e.value && e.value === "quarter") {
                                  props.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabTrendsQoQ);
                                }
                                props.changeUEDuration(e);
                              }}
                              className="match-type my-auto mx-0 w-100 tw-z-[3]"
                              autosize={true}
                            />
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                  {props.isExporterTableVisible === false || props.exporterTrendsTab === true || props.defaultData.showUiUeLevelTwo ? (
                    <div className="col-md-4 d-flex justify-content-center tw-px-0">
                      {props.defaultData.showUiUeLevelTwo && !(props.isExporterTableVisible === false && props.exporterTrendsTab === false) && !props.isMerged ? (
                        <div id="second-level-toggle" className="d-flex align-items-center justify-content-end ml-2">
                          <span className="mr-1 two_level_label">Enable 2nd Level Hierarchy</span>
                          <span className={props.defaultData.showUiUeLevelTwo && props.ueTwoLevel ? "twolevel-checkbox" : "twolevel-checkbox-uncheck"}>
                            <Form.Check
                              type="switch"
                              id="custom-switch-2"
                              checked={props.ueTwoLevel}
                              className={props.totalUniqueImporter > 5000 && props.isIntFilterApplied ? "tw-cursor-not-allowed" : ""}
                              onChange={(e) => {
                                // if (props.totalUniqueExporter > 5000 && props.isIntFilterApplied) {
                                //   toast.error("2nd level analytics is not available for more than 5000 companies if company level filters are applied.");
                                //   return;
                                // }
                                if (props.exporterTrendsTab && e.target.checked) {
                                  props.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabTrends2ndLevelAnalytics);
                                } else if (e.target.checked) {
                                  props.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabRank2ndLevelAnalytics);
                                }
                                props.changeUETwoLevelHandler(e);
                              }}
                            />
                          </span>
                        </div>
                      ) : null}
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className="tw-w-full tw-flex tw-justify-end">
                    <DemoTouchPoint module="finding_better_prospects_shipments_page_exporters_tab" />
                  </div>
                </div>
                <div className="tw-w-full">
                  <div className="tw-flex tw-justify-between">
                    <div>
                      <TabHeader
                        clearButton={() => props.clearButton}
                        addToFaV={props.addToFaV}
                        applyUIUEFilterHandler={props.applyUIUEFilterHandler}
                        setAddToFav={(val) => props.setAddtoFav(val)}
                        getUserPlan={() => props.getUserPlanHandler()}
                        trendsTab={props.trendsTab || props.exporterTrendsTab}
                        prospectData={props.prospectExporter}
                        type="Exporter"
                        userFirstPlan={props.userFirstPlan}
                        selectedData={props.selectedExporterRowData}
                        upgradePlansDictionary={props.upgradePlansDictionary}
                        userCredit={props.userCredit}
                        creditQuota={props.creditQuota}
                        totalDataCount={props.totalUniqueExporter}
                        defaultData={props.defaultData}
                        onDownload={(type, downloadFromValue, downloadToValue, closeDownloadFromModal) => props.downloadImpExpConfirm(type, downloadFromValue, downloadToValue, closeDownloadFromModal)}
                        onSelect={(closeDownloadFromModal) => props.mappingUniqueImporterExporter("XLS", "Exporter", closeDownloadFromModal)}
                        onClear={() => props.toggleClearButton("exporters")}
                        tradeDirection={props.defaultData.countryType}
                        dataSource={props.defaultData.country_small}
                        isSalesForceRedirection={props.isSalesForceRedirection}
                        currentUserPlan={props.currentUserPlan}
                        pathname={window.location.pathname}
                        analyticsCountryID={props.defaultData.analyticsCountryID}
                        isRedirect={props.isRedirect}
                        redirectingCompanyExporterId={props.redirectingCompanyExporterId}
                        redirectingCompanyImporterId={props.redirectingCompanyImporterId}
                        isTwoLevel={props.ueTwoLevel}
                        isMerged={props.isMerged}
                        showBolFilter={props.showBolFilter}
                        redirectionCompanyType={props.redirectionCompanyType}
                        allFilters={props.filterMapList}
                        emptyFilterObj={props.emptyFilterObj}
                        fromAccutalArrivalDate={props?.fromAccutalArrivalDate}
                        toAccutalArrivalDate={props?.toAccutalArrivalDate}
                        finalReqObj={props.finalReqObj}
                        currentTab={props.currentTab}
                        source="importer_exporter"
                      />
                    </div>
                    <div className="tw-flex tw-gap-2">
                      {props.exporterTrendsTab || (props.ueTwoLevel && !props.exporterTrendsTab) ? (
                        <div className="sort-dropdown d-flex tw-justify-end">
                          <DynamicDropdown
                            isOpen={activeDropdown === "sort"}
                            dropdownValue={activeDropdown}
                            onToggle={() => toggle("sort")}
                            onClose={close}
                            buttonLabel={`Analyse By: ${props.selectSortDefaltValueHandler(props.exporterSortValue).label}`}
                            options={props.importer_exporter_graph_sort__options}
                            onSelect={(item) => {
                              props.handleExporterSorting("exporter", { selector: item.value }, props.exporterSortOrderValue);
                              close();
                            }}
                            buttonId="sort-dropdown"
                            dropdownClassName="!tw-w-full"
                            icon={{ after: false, before: true, onClose: "swap_vert", onOpen: "swap_vert" }}
                          />
                        </div>
                      ) : null}
                      {((!!props.appliedStateFilterObject && props.checkforFilters(props.appliedStateFilterObject)) || (props.isSearchButtonCalled === true && props.searchedItem !== "")) && props.prospectImporter.length === 0 && props.currentPlanAccess && props.currentPlanAccess.is_internal_filter !== false && isWithinOneYear ? (
                        <Filters
                          clearFilter={() => {
                            props.clearFilterUE();
                          }}
                          currentUserPlan={props.currentUserPlan}
                          sendingDataToSearch={(data) => props.gettingDataFromUIEFilter(data)}
                          type="EXPORTER"
                          callingPendoEvent={(event) => props.checkPendoEventForCompanyRedirection(event)}
                          sendingAllData={(data) => props.gettingAllData(data)}
                          exporterData={props.exporterTab}
                          internalFilterList={props.defaultData.internalFilterList}
                        />
                      ) : (
                        <></>
                      )}
                      {props.ueTwoLevel && (
                        <DynamicDropdown
                          isOpen={activeDropdown === "secondLevel"}
                          dropdownValue={activeDropdown}
                          onToggle={() => toggle("secondLevel")}
                          onClose={close}
                          buttonLabel={`No. of 2nd Level Entities : ${props.secondLevelRowDropdownValue.label}`}
                          options={secondLevelRowsDropdown}
                          onSelect={(item) => {
                            props.onSecondLevelExporterRowDropdownChange(item);
                            close();
                          }}
                          dropdownClassName="!tw-w-full"
                          icon={{ after: true, before: false, onClose: "keyboard_arrow_down", onOpen: "keyboard_arrow_up" }}
                          buttonId="second-level-dropdown"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {(props.isExporterTableVisible === true || !props.defaultData.isImpExpGraph) && props.exporterTrendsTab === false ? (
                <div className={`${props.defaultData.showUiUeLevelTwo && props.ueTwoLevel ? "lvl-two-table-container lvl-two-i-e-l lvl-two-common-table " : ""} tw-border tw-rounded-lg`}>
                  <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" />
                  {!!props.isUEGridNew && props.isUEGridNew === true && !props.ueTwoLevel ? (
                    <>
                      <ReactTableTrademo
                        columns={props.exporterTableColumn}
                        data={props.defaultTrendsData}
                        paginationTotalRows={props.totalUniqueExporter}
                        onSelectedRowsChange={(selectedRows) => props.selectedExporterRowFun(selectedRows)}
                        //to enable 'asc' sorting only replace first 'desc' with 'asc'
                        onSort={(e) => props.handleExporterSortingClone(e, props.exporterSortOrderValue === "desc" ? "desc" : "desc")}
                        defaultSortField={props.defaultData.sortKeyUniqueImpExpMap[props.exporterSortValue] ? props.defaultData.sortKeyUniqueImpExpMap[props.exporterSortValue] : props.exporterDefaultSortValue ? props.exporterDefaultSortValue.columnKey : "date"}
                        defaultSortAsc={props.exporterSortOrderValue === "desc" ? false : true}
                        paginationPerPage={props.exporterPerPage}
                        onChangeRowsPerPage={props.handleSearchPerRowsExporterChangeClone}
                        onTableObjectChange={props.updateTrademoUETableObjectClone}
                        onChangePage={props.handlePerRowsChangeExporterClone}
                        paginationDefaultPage={props.exporterCurrentPage}
                        noDataComponent={props.isLoaderActive === true || props.isDownloadLoaderActive === true || props.isTrendsActive ? "" : "No Unique Exporter Found"}
                        clearSelectedRows={props.exporterToggleRows}
                        selectedData={props.selectedExporterRowData}
                        shipmentDefaultSortValue={props.defaultData.exporterSorting}
                        sortOrderValue={props.exporterSortOrderValue}
                        hideSorting={true}
                        fixSelection="start"
                        options={[25, 50, 100]}
                        blockAscSorting={true}
                      />
                      <ReactTooltip5 className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="right" id={`address-tooltip`} />
                    </>
                  ) : props?.secondLevelData?.length ? (
                    //this is rank 2nd level table
                    <div className="lvl-two-table-container-left">
                      <DataTable
                        title="Data3"
                        columns={props.exporterTableColumn}
                        className="!tw-min-h-[408px]"
                        data={!!props.defaultTrendsData && props.defaultTrendsData.length !== 0 && props.ueTwoLevel === false ? props.defaultTrendsData : props?.secondLevelData?.length ? props.secondLevelData : []}
                        paginationTotalRows={props.totalUniqueExporter}
                        paginationRowsPerPageOptions={[props.secondLevelRowDropdownValue.value * 5, props.secondLevelRowDropdownValue.value * 10, props.secondLevelRowDropdownValue.value * 20]}
                        customStyles={customStyles}
                        onSort={(e) => props.handleExporterSorting("importer", e, props.exporterSortOrderValue === "desc" ? "desc" : "desc")}
                        paginationPerPage={props.exporterPerPage}
                        onChangeRowsPerPage={props.handleSearchPerRowsExporterChange}
                        onChangePage={() => null}
                        paginationDefaultPage={props.exporterCurrentPage}
                        sortIcon={props.exporterSortOrderValue === "desc" ? <AscSortIcon height={"16px"} width={"16px"} color={"#101828"} /> : <DescSortIcon height={"16px"} width={"16px"} color={"#101828"} />}
                        pagination
                        highlightOnHover={false}
                        persistTableHead
                        sortServer={true}
                        paginationIconPrevious={
                          <ChevronLeft
                            color={props.defaultPage > 1 ? "rgba(0,0,0,0.54)" : "#D1D1D1"}
                            onClick={() => {
                              props.prevSecondLevelHandler();
                            }}
                          />
                        }
                        paginationIconNext={
                          <ChevronRight
                            color={"rgba(0,0,0,0.54)"}
                            onClick={() => {
                              props.nextSecondLevelHandler();
                            }}
                          />
                        }
                      />
                      <ReactTooltip5 className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="right" id={`address-tooltip`} />
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              ) : props.exporterTrendsTab === true ? (
                <div>
                  <TrendsData
                    isTrendsTab={props.currentTab === tabKeywords.importers ? props.trendsTab : props.exporterTrendsTab}
                    isTwoLevel={props.currentTab === tabKeywords.importers ? props.uiTwoLevel : props.ueTwoLevel}
                    dynamicTrendsData={props.dynamicTrendsData}
                    filterObj={props.filterObj}
                    handleChangePerPage={(e) => {
                      props.UEHandlerPerPage(e);
                    }}
                    showPopup={props.showPopup}
                    applyUIUEFilterHandler={props.applyUIUEFilterHandler}
                    setShowPopup={(val) => props.setShowPopUp(val)}
                    isNewShow={props.isUEGridNew}
                    analyticsTrends_mustnot_Data={props.analyticsTrends_mustnot_Data}
                    defaultTrendsData={!!props.defaultTrendsData && props.defaultTrendsData.length !== 0 && props.ueTwoLevel === false ? props.defaultTrendsData : props?.secondLevelData?.length ? props.secondLevelData : []}
                    paginationDefaultPage={props.exporterCurrentPage}
                    onTableObjectChange={props.updateTrademoUETableObjectClone}
                    clearButton={props.clearButtonState}
                    clearSelectedRows={props.exporterToggleRows}
                    selectedRows={props.prospectExporter}
                    currentUserPlan={props.currentUserPlan}
                    pathname={window.location.pathname}
                    analyticsCountryID={props.defaultData.analyticsCountryID}
                    paginationTotalRows={props.totalUniqueExporter}
                    totalCompanyCount={props.totalUniqueExporter}
                    onSelectedRowsChange={(selectedRows) => props.selectedExporterRowFun(selectedRows)}
                    selectedData={props.selectedExporterRowData}
                    sortType={props.exporterSortValue}
                    currentTab={props.currentTab}
                    requestObj={props.existingSearchReqObj}
                    currentKeyViewTrendItem={props.finalReqObj}
                    timeFrame={props.currentExporterFrame}
                    onChangePage={props.handlePerRowsChangeExporterClone}
                    viewTrends={() => props.getUniqueExporterData(requestObjectTypeDictionary.exporters, "pagination")}
                    handleTrendsSorting={(data1, data2) => props.handleTrendsSorting(data1, data2)}
                    defaultSort={props.expDefaultSort}
                    paginationPerPage={props.exporterPerPage}
                    defaultSortAsc={props.exporterSortOrderValue === "desc" ? false : true}
                    defaultData={props.defaultData}
                    resetSecondLevel={() => props.resetSecondLevel}
                    currentPlanAccess={props.currentPlanAccess}
                    onChangeRowsPerPage={props.handleSearchPerRowsExporterChangeClone}
                    isLoaderActive={props.isLoaderActive || props.isDownloadLoaderActive === true || props.isTrendsActive}
                    selectSortDefaltValueHandler={props.selectSortDefaltValueHandler(props.exporterSortValue)}
                    isSalesForceRedirection={props.isSalesForceRedirection}
                    twoColumnMapping={props.defaultData.twoColumnMapping}
                    defaultUiUeTwoLevelSelctedHeading={props.defaultUiUeTwoLevelSelctedHeading}
                    selectedUiUeTwoLevelHeading={(data) => props.selectedUiUeTwoLevelHeading(data)}
                    showTwoLevel={props.ueTwoLevel}
                    viewAllPerPage={props.exporterPerPage}
                    defaultPage={props.defaultPage}
                    isRedirect={props.isRedirect}
                    sortOrderValue={props.exporterSortOrderValue}
                    redirectingCompanyExporterId={props.redirectingCompanyExporterId}
                    redirectingCompanyImporterId={props.redirectingCompanyImporterId}
                    viewTrendsFinalSearchReqObj={props.finalReqObj}
                    secondLevelRowDropdownValue={props.secondLevelRowDropdownValue.value}
                    updatingMustNot={(data) => {
                      props.updatingMustNot(data);
                    }}
                    trendsTab={props.trendsTab}
                    handleIESorting={props.exporterSortValue}
                    isGridNew={props.isUEGridNew}
                    fixedLengthUpto={props.fixedLengthUptoTrend}
                    paginationIconPrevious={
                      <ChevronLeft
                        color={props.defaultPage > 1 ? "rgba(0,0,0,0.54)" : "#D1D1D1"}
                        onClick={() => {
                          props.prevSecondLevelHandler();
                        }}
                      />
                    }
                    paginationIconNext={
                      <ChevronRight
                        color={"rgba(0,0,0,0.54)"}
                        onClick={() => {
                          props.nextSecondLevelHandler();
                        }}
                      />
                    }
                    defaultSortField={props.defaultData.sortKeyUniqueImpExpMap[props.exporterSortValue] ? props.defaultData.sortKeyUniqueImpExpMap[props.exporterSortValue] : props.exporterDefaultSortValue ? props.exporterDefaultSortValue.columnKey : "date"}
                    shipmentDefaultSortValue={props.defaultData.exporterSorting}
                  />
                </div>
              ) : props.currentTab === tabKeywords.exporters && props.isLoaderActive === false && !!props.existingUniqueImpExpReqObj.toDate && props.redirectingCompanyExporterId !== "" && !!props.defaultData.isImpExpGraph ? (
                <div>
                  <div className="hr mt-2 mb-3" />
                  <ImporterExporterGraph
                    companyName={props.redirectingCompanyName}
                    type="EXPORTER"
                    totalCount={props.totalUniqueExporter}
                    searchReqObj={props.existingUniqueImpExpReqObj}
                    isInternalFilterApplied={(!!props.uniqueImportExporterShipment && props.uniqueImportExporterShipment.length > 0) || (!!props.uniqueImportExporterWeight && props.uniqueImportExporterWeight.length > 0) || (!!props.uniqueImportExporterTeu && props.uniqueImportExporterTeu.length > 0) || (!!props.uniqueImportExporterValue && props.uniqueImportExporterValue.length > 0) ? true : false}
                    uniqueImportExporterShipment={!!props.uniqueImportExporterShipment && props.uniqueImportExporterShipment.length > 0 ? props.uniqueImportExporterShipment : ""}
                    uniqueImportExporterWeight={!!props.uniqueImportExporterWeight && props.uniqueImportExporterWeight.length > 0 ? props.uniqueImportExporterWeight : ""}
                    uniqueImportExporterTeu={!!props.uniqueImportExporterTeu && props.uniqueImportExporterTeu.length > 0 ? props.uniqueImportExporterTeu : ""}
                    uniqueImportExporterValue={!!props.uniqueImportExporterValue && props.uniqueImportExporterValue.length > 0 ? props.uniqueImportExporterValue : ""}
                    impExpGraphDataApi={props.defaultData.apiEndPoints.getImpExpGraphData}
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(Exporter);
